import React from 'react';

import Card, { CardLink } from '@rover/components/src/cards/Card';
import CarouselRight from '@rover/icons/svg/carousel-right.svg';
import Grooming from '@rover/icons/svg/grooming.svg';
import { Box, Flex, Heading, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import NewServiceBadge from '@rover/react-lib/src/pages/grooming/components/NewServiceBadge';

import emitMetricOnCtaClick from '../emitMetricOnCtaClick';

const ICON_SIZE = '32px';

const GroomingPilotCard: React.FC = () => {
  const { background, shadows, textColor } = useTheme();

  return (
    <Card
      display={['none', 'block']}
      padding="0x"
      borderColor="transparent"
      backgroundColor={background.overlay}
      borderRadius="8px"
      sx={{
        boxShadow: shadows.elevation_mid,
      }}
    >
      <CardLink
        href="/grooming/search/"
        aria-label="Explore Rover's new grooming service"
        onClick={() => emitMetricOnCtaClick('grooming-homepage-cta-click')}
      />
      <Flex alignItems="center" paddingX="6x" paddingY="4x">
        <Box flexShrink="0">
          <Grooming width={ICON_SIZE} height={ICON_SIZE} fill={textColor.primary_inverse} />
        </Box>
        <Flex flexDirection="column" flexGrow="1" paddingLeft="5x" paddingRight="3x">
          <Flex alignItems="center">
            <Heading webProps={{ as: 'div' }} m="0x" size="200" textColor="primary_inverse">
              Grooming
            </Heading>
            <Box ml="2x">
              <NewServiceBadge />
            </Box>
          </Flex>
          <Text textColor="primary_inverse">
            Explore Rover's new service: at-home bathing and grooming
          </Text>
        </Flex>
        <CarouselRight width={ICON_SIZE} height={ICON_SIZE} fill={textColor.primary_inverse} />
      </Flex>
    </Card>
  );
};

export default GroomingPilotCard;
